import contactForm from '@app/components/Blocks/contactForm.vue';
import downloads from '@app/components/Blocks/downloads.vue';
import hero from '@app/components/Blocks/hero.vue';
import image from '@app/components/Blocks/image.vue';
import map from '@app/components/Blocks/map.vue';
import simpleText from '@app/components/Blocks/simpleText.vue';
import simpleTextImage from '@app/components/Blocks/simpleTextImage.vue';
import tile from '@app/components/Blocks/tile.vue';
import video from '@app/components/Blocks/video.vue';
var Blocks = {
    contactForm: contactForm,
    downloads: downloads,
    hero: hero,
    image: image,
    map: map,
    simpleText: simpleText,
    simpleTextImage: simpleTextImage,
    tile: tile,
    video: video,
    registerBlock: function (name, block) {
        this[name] = block;
    }
};
export default Blocks;
